import { Stack } from '@mui/material';
import { FC } from 'react';

import { GetInstrumentsQuery, GetInstrumentsResponseItem } from '@Common/types/bo/instruments';

import { IdArrayInput } from '@sh4res/bo-common/components';
import { B2bInvestorProfileGridColumn } from '@sh4res/bo-common/resources/investor_profile/components/B2bInvestorProfileGrid/components/B2bInvestorProfileGridColumn/B2bInvestorProfileGridColumn';
import { B2bInvestorProfileGridOrdinatesColumn } from '@sh4res/bo-common/resources/investor_profile/components/B2bInvestorProfileGrid/components/B2bInvestorProfileGridOrdinatesColumn/B2bInvestorProfileGridOrdinatesColumn';
import { useB2bInvestorProfileGridLogic } from '@sh4res/bo-common/resources/investor_profile/components/B2bInvestorProfileGrid/hooks/useB2bInvestorProfileGridLogic';
import { isBoExternal } from '@sh4res/bo-common/utils/env';

export const B2bInvestorProfileGrid: FC = () => {
  const { currentGrid, grid_template, product_category } = useB2bInvestorProfileGridLogic();

  if (grid_template === undefined || product_category === undefined) {
    return null;
  }

  return (
    <Stack direction="column" width="100%" spacing={3}>
      <IdArrayInput<GetInstrumentsQuery, GetInstrumentsResponseItem>
        source="instruments"
        reference="instruments"
        label={false}
        addIdLabel="resources.bo_common.b2b.investor_profile.create.grid_configuration.add_assets"
        getLabel={(instrument) =>
          (isBoExternal() ? instrument.short_name : instrument.name) || instrument.symbol
        }
        sort={{ field: 'short_name', order: 'ASC' }}
        searchLimit={50}
        searchFilter={{
          is_plan_universe_eligible: true,
        }}
        data-testid="BoExternalB2bInvestorProfileGrid_InstrumentsIdArrayInput"
      />

      {currentGrid.length > 0 ? (
        <Stack direction="row" spacing={3} overflow="scroll">
          {product_category !== 'PEE' && product_category !== 'PEEG' && (
            <B2bInvestorProfileGridOrdinatesColumn currentGrid={currentGrid} />
          )}
          {currentGrid.map((column, index) => (
            <B2bInvestorProfileGridColumn
              key={column.instrument_id}
              columnIdx={index}
              allocation={column}
            />
          ))}
        </Stack>
      ) : null}
    </Stack>
  );
};
